import axios from 'axios';

const TOKEN_KEY = 'sports_auth_token';
const USER_KEY = 'sports_auth_user';

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const isAuthenticated = () => Boolean(getAuthToken());

export const setAuthSession = ({ token, user }) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
};

export const clearAuthSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const setupAxiosAuth = (onUnauthorized) => {
  const requestId = axios.interceptors.request.use((config) => {
    const token = getAuthToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  const responseId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestUrl = String(error?.config?.url || '');
      const isLoginRequest = requestUrl.includes('/api/auth/login');

      if (status === 401 && !isLoginRequest) {
        clearAuthSession();
        if (typeof onUnauthorized === 'function') {
          onUnauthorized();
        }
      }

      return Promise.reject(error);
    }
  );

  return () => {
    axios.interceptors.request.eject(requestId);
    axios.interceptors.response.eject(responseId);
  };
};
